<template>
    <tr>
        <th>{{ label }}</th>
        <td class="md:w-2/5 md:max-w-xs">
            <span v-if="inputToggled">
                <edit-password
                    v-model="value"
                    @validation-change="isPasswordValidAndConfirmed = $event"
                    @password-confirmation-update="handlePasswordConfirmationUpdate"
                />
            </span>
            <span v-else>**********</span>
        </td>
        <td class="text-right">
            <div v-if="inputToggled" class="flex flex-col-reverse md:flex-row md:justify-end">
                <button
                    type="button"
                    class="btn btn-md is-ghost mr-md"
                    tabindex="4"
                    @click="cancel"
                >
                    {{ lang('Avbryt','Cancel') }}
                </button>
                <button
                    type="button"
                    class="btn btn-md is-primary my-md md:my-0"
                    :class="{ 'is-loading': loading }"
                    :disabled="loading || ! isPasswordValidAndConfirmed"
                    tabindex="3"
                    @click="updateValue"
                >
                    {{ lang('Spara','Save') }}
                </button>
            </div>
            <button
                v-else
                type="button"
                class="btn btn-md is-ghost mb-xl md:mb-0"
                @click="toggleInput"
            >
                {{ lang('Redigera','Edit') }}
            </button>
        </td>
    </tr>
</template>

<script>
    import EditProfileInfo from './EditProfileInfo';

    export default {
        extends: EditProfileInfo,

        data() {
            return {
                isPasswordValidAndConfirmed: false,
                passwordConfirmation: '',
            };
        },

        methods: {
            handlePasswordConfirmationUpdate(passwordConfirmation) {
                this.passwordConfirmation = passwordConfirmation;
            },
            cancel() {
                this.value = null;
                this.passwordConfirmation = null;
                this.toggleInput();
            },

            sendUpdateRequest() {
                return axios.patch(route('front.my-pages.api.password.update'), {
                    password: this.value,
                    password_confirmation: this.passwordConfirmation,
                });
            },

            handleResponseData(responseData) {
                this.value = null;
                this.passwordConfirmation = null;

                flash_success();
            },
        },
    };
</script>
